import script from "./ClonarModeloModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClonarModeloModal.vue?vue&type=script&lang=ts&setup=true"

import "./ClonarModeloModal.vue?vue&type=style&index=0&id=114c258f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-114c258f"]])

export default __exports__